import { render } from "./PensionPayments.vue?vue&type=template&id=99b0e3ca&ts=true"
import script from "./PensionPayments.vue?vue&type=script&lang=ts"
export * from "./PensionPayments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__